import React from 'react';
import "../Figure.css"


function Figure6() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th></th>
              <th> Cd concentration after incubation (30min)</th>
              <th> Cd uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Water </th>
              <td> 0.305 mg/L </td>
              <td> 0 mg/L </td>
            </tr> 
            <tr>
              <th> EC20 </th>
              <td> 0.256 mg/L </td>
              <td> 0.049 mg/L </td>
            </tr> 
            <tr>
              <th> SpaC </th>
              <td> 0.281 mg/L </td>
              <td> 0.024 mg/L </td>
            </tr> 
            <tr>
              <th className="colored-cell" colSpan="2"> Uptake difference </th>
              <th className="colored-cell"> 0.025 mg/L </th>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}

export default Figure6;